import React from "react";
import Skeleton from 'react-loading-skeleton';

const ForYouSkeleton = () => {
    return <>
        <div style={{ marginBottom: "10px", marginTop: "10px" }}>
            <Skeleton height={132} />
        </div>
        <div style={{ marginTop: "20px" }}>
            <Skeleton height={11} />
        </div>
        <div style={{ marginTop: "8px" }}>
            <Skeleton height={11} />
        </div>
        <div style={{ marginTop: "15px" }}>
            <Skeleton height={11} width={178} />
        </div>
    </>
}

export default ForYouSkeleton;